import React from "react";
import T from "prop-types";
import api from "APP_ROOT/api";
import StatTooltip from "../StatTooltip";
import Detail from "./Detail";
import Summary from "./Summary";

export default function PartStatsTooltip({ part }) {
  return (
    <StatTooltip
      fetchStats={() =>
        api.reports.part_stats.search(part.id).then(res => res.data)}
      renderStats={stats => <Summary stats={stats} />}
      renderModal={stats => <Detail stats={stats} />}
      modalTitle={part.part_number}
    />
  );
}

PartStatsTooltip.propTypes = {
  part: T.shape({
    id: T.number.isRequired,
    part_number: T.string.isRequired
  }).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/shared/components/StatsTooltip/PartStats/PartStatsTooltip.jsx